import * as React from "react";

import BaseCalendarView, {
  type BaseCalendarViewProps,
  type CalendarWithOptionalHeaderViewProps,
  type SingleSelectionCalendarViewProps,
} from "./BaseCalendarView";
import Calendar from "./Calendar";
import Body, { type BodyWidth } from "./CalendarBody/Body";
import Header, { type HeaderProps } from "./CalendarHeader/Header";

type MinuteViewProps = BaseCalendarViewProps &
  SingleSelectionCalendarViewProps &
  CalendarWithOptionalHeaderViewProps & {
    /** Number of minute cells per row. */
    width: BodyWidth;
  };

class MinuteView extends BaseCalendarView<MinuteViewProps, unknown> {
  public render() {
    const {
      values,
      hasHeader,
      onValueClick,
      onNextPageBtnClick,
      onPrevPageBtnClick,
      hasNextPage,
      hasPrevPage,
      onHeaderClick,
      activeItemIndex,
      currentHeadingValue,
      hoveredItemIndex,
      disabledItemIndexes,
      onCellHover,
      onMount: _onMount,
      inline,
      localization,
      pickerWidth,
      pickerStyle,
      width,
    } = this.props;
    const headerProps = {
      className: "suicr-minute-view-header",
      onHeaderClick,
      onNextPageBtnClick,
      onPrevPageBtnClick,
      hasNextPage,
      hasPrevPage,
      title: currentHeadingValue,
      width,
      displayWeeks: false,
      localization,
    } as HeaderProps;

    return (
      <Calendar
        ref={(e: HTMLTableElement | null) => {
          this.calendarNode = e;
        }}
        outlineOnFocus={!!inline}
        pickerWidth={pickerWidth}
        pickerStyle={pickerStyle}
      >
        {hasHeader && <Header {...headerProps} />}
        <Body
          width={width}
          data={values}
          hovered={hoveredItemIndex}
          onCellHover={onCellHover}
          onCellClick={onValueClick}
          active={activeItemIndex}
          disabled={disabledItemIndexes}
        />
      </Calendar>
    );
  }
}

export default MinuteView;
